'use client'

import React, { FC, ReactElement } from 'react'
import CollectionStat from '@/components/collection-stat'
import useSatoshiPriceUSD from '@/utils/hooks/useSatoshiPriceUSD'
import useSatoshiPrice from '@/utils/hooks/useSatoshiPrice'
import BitcoinIcon from '@/icons/bitcoin-filled'
import useUSDToggle from '@/utils/hooks/useUSDToggle'

const CollectionSatoshiStat: FC<{
	title: string
	satoshis: number
	valueClassName?: string
	valueIcon?: React.FC<{
		className?: string
	}>
	variant?: 'small'
	className?: string
	isLoading?: boolean
	per?: string
}> = (props): ReactElement => {
	const { title, satoshis, per } = props
	const [showUSD, setShowUSD] = useUSDToggle()

	const formattedSatoshis = useSatoshiPrice(satoshis)
	const price = per === 'sats' ? `${satoshis} sats` : formattedSatoshis
	const [priceUSD, _isLoadingPriceUSD] = useSatoshiPriceUSD(satoshis)

	let isLoading = (showUSD) ? false : false
	let value = (showUSD) ? `$${priceUSD}` : price

	if (!price) {
		value = showUSD ? '$0' : '0.0'
		isLoading = false
	}

	return (
		<CollectionStat
			value={value}
			isLoading={isLoading || props?.isLoading}
			onClick={() => setShowUSD(!showUSD)}
			title={title}
			valueIcon={showUSD || per === 'sats' ? () => <div></div> : BitcoinIcon}
			variant={props?.variant}
			className={props?.className}
		/>
	)
}

export default CollectionSatoshiStat
